import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack, Typography, Button } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import HomeIcon from "@mui/icons-material/Home";

/**
 * Página de acceso no autorizado (Error 403)
 *
 * Se muestra cuando un usuario intenta acceder a una ruta sin los permisos necesarios.
 * Proporciona un mensaje claro y opciones para volver al inicio.
 */
export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 200px)",
        px: 2,
      }}
    >
      <Stack
        alignItems="center"
        spacing={3}
        sx={{
          maxWidth: 500,
          textAlign: "center",
        }}
      >
        {/* Icono de candado */}
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: "error.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LockIcon sx={{ fontSize: 48, color: "error.main" }} />
        </Box>

        {/* Título */}
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 500,
            color: "text.primary",
          }}
        >
          Acceso No Autorizado
        </Typography>

        {/* Mensaje */}
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
          }}
        >
          No tienes los permisos necesarios para acceder a esta página.
          <br />
          Si crees que esto es un error, contacta al administrador del sistema.
        </Typography>

        {/* Botones de acción */}
        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/")}
            size="large"
          >
            Ir al Inicio
          </Button>
          <Button variant="outlined" onClick={() => navigate(-1)} size="large">
            Volver
          </Button>
        </Stack>

        {/* Información adicional */}
        <Typography
          variant="caption"
          sx={{
            color: "text.disabled",
            mt: 4,
          }}
        >
          Código de error: 403 Forbidden
        </Typography>
      </Stack>
    </Box>
  );
};

export default UnauthorizedPage;
